import Vue from 'vue'
import Axios from 'axios'

export default {//经常调用的接口
    // wrong_Statistics({ state, commit },_type) {  //埋点
    //     // 1 数学小题详情页视频开通按钮
    //     // 2 查看错题解析按钮
    //     // 3 立即订购按钮
    //     return new Promise((resolve, reject) => {
    //         Axios.post(API_URL_HD + '/wrong_question_clear/statistics/ ', {"type":_type}).then(res => {
    //             resolve();
    //         })
    //     })
    // },
}
